(function(){
  var d=document,root=d.documentElement;
  var ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';

  // ---------- tidy page/policy content ----------
  d.querySelectorAll('[data-sg-tidy], .shopify-policy__body .rte, .shopify-policy__body').forEach(function(box){
    box.querySelectorAll('p,div,span').forEach(function(el){
      if(el.closest('.sg-faq'))return;
      var txt=(el.textContent||'').replace(/\u00a0/g,' ').trim();
      if(!txt&&!el.querySelector('img,iframe,video,svg,input,a,br+*'))el.remove();
    });
    box.querySelectorAll('p').forEach(function(p){
      var t=p.textContent.trim(),s=p.querySelector('strong,b');
      if(s&&t&&s.textContent.trim()===t&&t.length<80&&!p.querySelector('br'))p.classList.add('sg-subhead');
    });
  });

  // ---------- turn FAQ page content into an accordion ----------
  d.querySelectorAll('[data-sg-faqify]').forEach(function(box){
    var kids=[].slice.call(box.children),items=[],intro=[],cur=null;
    var isQ=function(el){
      if(/^H[2-6]$/.test(el.tagName))return el.textContent.trim();
      var f=el.firstElementChild;if(!f||!/^(STRONG|B)$/.test(f.tagName))return null;
      var ft=f.textContent.trim();if(ft.length<4)return null;
      var before='';for(var n=el.firstChild;n&&n!==f;n=n.nextSibling)before+=n.textContent||'';
      return before.trim()?null:ft;
    };
    kids.forEach(function(el){
      var q=isQ(el);
      if(q){
        cur={q:q,a:[]};items.push(cur);
        if(!/^H/.test(el.tagName)){var c=el.cloneNode(true);c.removeChild(c.firstElementChild);while(c.firstChild&&(c.firstChild.nodeName==='BR'||(c.firstChild.nodeType===3&&!c.firstChild.textContent.trim())))c.removeChild(c.firstChild);if(c.textContent.trim()||c.querySelector('img,a'))cur.a.push(c)}
      }else if(cur){cur.a.push(el.cloneNode(true))}else{intro.push(el)}
    });
    if(items.length<2)return;
    var list=d.createElement('div');list.className='sg-faq';list.setAttribute('data-sg-faq','');
    items.forEach(function(it,i){
      var w=d.createElement('div');w.className='sg-faq__item';
      var b=d.createElement('button');b.type='button';b.className='sg-faq__q';b.setAttribute('aria-expanded','false');b.textContent=it.q.replace(/[:\s]+$/,'');
      var ic=d.createElement('span');ic.className='sg-faq__icon';ic.setAttribute('aria-hidden','true');b.appendChild(ic);
      var a=d.createElement('div');a.className='sg-faq__a';var inner=d.createElement('div');
      it.a.forEach(function(n){if(n.tagName==='P'||n.tagName==='UL'||n.tagName==='OL')inner.appendChild(n);else{var p=d.createElement('p');p.appendChild(n);inner.appendChild(p)}});
      a.appendChild(inner);w.appendChild(b);w.appendChild(a);list.appendChild(w);
    });
    box.innerHTML='';intro.forEach(function(n){box.appendChild(n)});box.appendChild(list);
  });
  root.classList.remove('no-js');root.classList.add('sg-js');
  var reduce=(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)||d.body.getAttribute('data-sg-motion')==='off';
  var allowCursor=d.body.getAttribute('data-sg-cursor')!=='off',allowTrail=d.body.getAttribute('data-sg-trail')!=='off';

  // header shadow, slime progress bar, scroll-velocity drip stretch
  var hdr=d.querySelector('[data-sg-header]'),lastY=window.scrollY,stretch=0,raf=null;
  var tick=function(){
    var y=window.scrollY,h=d.documentElement.scrollHeight-innerHeight;
    if(hdr)hdr.classList.toggle('is-scrolled',y>8);
    root.style.setProperty('--sg-p',h>0?(y/h).toFixed(4):0);
    if(!reduce){var v=Math.min(Math.abs(y-lastY)/40,1);stretch=Math.max(stretch*.9,v);root.style.setProperty('--sg-stretch',stretch.toFixed(3));}
    lastY=y;
    if(stretch>.01){raf=requestAnimationFrame(tick)}else{raf=null;root.style.setProperty('--sg-stretch',0)}
  };
  tick();window.addEventListener('scroll',function(){if(!raf)raf=requestAnimationFrame(tick)},{passive:true});

  // faq accordion (one open at a time)
  d.querySelectorAll('[data-sg-faq]').forEach(function(list){
    list.querySelectorAll('.sg-faq__q').forEach(function(q){q.addEventListener('click',function(){
      var it=q.closest('.sg-faq__item'),was=it.classList.contains('is-open');
      list.querySelectorAll('.sg-faq__item.is-open').forEach(function(o){o.classList.remove('is-open');o.querySelector('.sg-faq__q').setAttribute('aria-expanded','false')});
      if(!was){it.classList.add('is-open');q.setAttribute('aria-expanded','true')}
    })});
  });

  // mobile drawer
  var drawer=d.querySelector('[data-sg-drawer]');
  if(drawer){
    var open=function(v){drawer.classList.toggle('is-open',v);d.body.style.overflow=v?'hidden':''};
    d.querySelectorAll('[data-sg-menu-open]').forEach(function(b){b.addEventListener('click',function(){open(true)})});
    drawer.querySelectorAll('[data-sg-menu-close]').forEach(function(b){b.addEventListener('click',function(){open(false)})});
    d.addEventListener('keydown',function(e){if(e.key==='Escape')open(false)});
  }

  // scroll reveal with stagger
  var els=d.querySelectorAll('[data-reveal]');
  var revealAll=function(){els.forEach(function(el){el.classList.add('is-in')})};
  if('IntersectionObserver' in window&&!reduce&&d.visibilityState==='visible'&&!(window.Shopify&&Shopify.designMode)){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(el){
      var p=el.parentElement;if(p&&p.hasAttribute('data-stagger')){el.style.setProperty('--i',Array.prototype.indexOf.call(p.children,el)%8)}
      if(el.getBoundingClientRect().top<innerHeight){el.classList.add('is-in')}else{io.observe(el)}
    });
    setTimeout(function(){els.forEach(function(el){if(!el.classList.contains('is-in')&&el.getBoundingClientRect().top<innerHeight*1.1)el.classList.add('is-in')})},2500);
    d.addEventListener('visibilitychange',function(){if(d.visibilityState!=='visible')revealAll()});
  }else{revealAll()}

  // footer wordmark letters
  d.querySelectorAll('[data-sg-letters]').forEach(function(el){
    var t=el.textContent.trim();el.textContent='';
    t.split('').forEach(function(ch){var s=d.createElement('span');s.textContent=ch;el.appendChild(s)});
  });

  // collection sort
  d.querySelectorAll('[data-sg-sort]').forEach(function(sel){
    sel.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',sel.value);u.searchParams.delete('page');location.href=u.toString()});
  });

  // qty steppers
  d.querySelectorAll('[data-sg-qty]').forEach(function(w){
    var i=w.querySelector('input');
    w.querySelectorAll('button').forEach(function(b){b.addEventListener('click',function(){
      var min=parseInt(i.min||'0',10),v=(parseInt(i.value,10)||0)+(b.dataset.step==='-'?-1:1);
      i.value=Math.max(min,v);i.dispatchEvent(new Event('change',{bubbles:true}));
    })});
  });

  // product page
  var pj=d.getElementById('sgVariants');
  if(pj){
    var variants=JSON.parse(pj.textContent),form=d.querySelector('.sg-product-form');
    var idSel=form.querySelector('[name="id"]'),btn=form.querySelector('[data-sg-add]'),price=d.querySelector('[data-sg-price]'),main=d.querySelector('[data-sg-main-img]');
    var swap=function(src){if(!main||!src||main.getAttribute('src')===src)return;main.classList.add('is-swap');setTimeout(function(){main.src=src;main.onload=function(){main.classList.remove('is-swap')}},180)};
    var update=function(){
      var chosen=[];form.querySelectorAll('[data-sg-opt]').forEach(function(fs){var c=fs.querySelector('input:checked');chosen.push(c?c.value:null)});
      var v=variants.find(function(x){return x.options.every(function(o,i){return o===chosen[i]})});
      if(!v){btn.disabled=true;btn.querySelector('span').textContent='unavailable';return}
      idSel.value=v.id;btn.disabled=!v.available;btn.querySelector('span').textContent=v.available?btn.dataset.label:'sold out';
      if(price)price.innerHTML=v.price+(v.compare?' <s>'+v.compare+'</s>':'');
      var p2=d.querySelector('[data-sg-price2]');if(p2)p2.innerHTML=v.price;
      var sb=d.querySelector('[data-sg-sticky-add]');if(sb)sb.disabled=!v.available;
      var qn=form.querySelector('[name="quantity"]'),qv=qn?Math.max(1,parseInt(qn.value,10)||1):1;
      d.querySelectorAll('[data-sg-buynow],[data-sg-sticky-buy]').forEach(function(a){a.href=ROOT+'cart/'+v.id+':'+qv;a.classList.toggle('is-off',!v.available)});
      var p3=d.querySelector('[data-sg-price3]');if(p3)p3.innerHTML=v.price;
      if(v.img)swap(v.img);
      var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u.toString());
    };
    form.querySelectorAll('[data-sg-opt] input').forEach(function(r){r.addEventListener('change',update)});
    d.querySelectorAll('[data-sg-thumb]').forEach(function(t){t.addEventListener('click',function(){
      d.querySelectorAll('[data-sg-thumb]').forEach(function(x){x.classList.remove('is-active')});t.classList.add('is-active');swap(t.dataset.src);
    })});
  }

  // cart: auto-submit on qty change
  var cf=d.querySelector('[data-sg-cart]');
  if(cf){var tmr;cf.querySelectorAll('[data-sg-qty] input').forEach(function(i){i.addEventListener('change',function(){clearTimeout(tmr);tmr=setTimeout(function(){var h=d.createElement('input');h.type='hidden';h.name='update';h.value='1';cf.appendChild(h);cf.submit()},500)})})}

  // ---------- impulse add-to-cart ----------
  var buyQty=d.querySelector('.sg-product-form [name="quantity"]');
  if(buyQty){buyQty.addEventListener('change',function(){var q=Math.max(1,parseInt(buyQty.value,10)||1);d.querySelectorAll('[data-sg-buynow],[data-sg-sticky-buy]').forEach(function(a){a.href=a.href.replace(/:\d+$/,':'+q)})})}
  var burst=function(el){if(reduce||!el)return;var r=el.getBoundingClientRect(),cx=r.left+r.width/2,cy=r.top+r.height/2,cols=['#ff8fc8','#b693ff','#8fe6b4','#ffd966','#8fdcff'];
    for(var k=0;k<16;k++){var s=d.createElement('span'),a=Math.random()*Math.PI*2,dist=40+Math.random()*60;s.className='sg-burst';s.style.left=cx+'px';s.style.top=cy+'px';s.style.background=cols[k%5];s.style.setProperty('--dx',Math.cos(a)*dist+'px');s.style.setProperty('--dy',Math.sin(a)*dist+'px');d.body.appendChild(s);(function(x){setTimeout(function(){x.remove()},850)})(s)}};
  var toast;
  var showToast=function(title,img){
    if(!toast){toast=d.createElement('div');toast.className='sg-toast';toast.setAttribute('role','status');toast.innerHTML='<img alt=""><div><b>added to cart!</b><small></small></div><button class="sg-toast__x" type="button" aria-label="Close">×</button><div class="sg-toast__ctas"><a class="sg-btn sg-btn--white" href="'+ROOT+'cart">view cart</a><a class="sg-btn sg-btn--pink" href="'+ROOT+'checkout">checkout →</a></div>';d.body.appendChild(toast);toast.querySelector('.sg-toast__x').addEventListener('click',function(){toast.classList.remove('is-on')})}
    var im=toast.querySelector('img');if(img){im.src=img;im.style.display=''}else{im.style.display='none'}
    toast.querySelector('small').textContent=title||'';
    toast.classList.remove('is-on');void toast.offsetWidth;toast.classList.add('is-on');
    clearTimeout(toast._t);toast._t=setTimeout(function(){toast.classList.remove('is-on')},6000);
  };
  var refreshCount=function(){return fetch(ROOT+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){
    d.querySelectorAll('.sg-cart-btn').forEach(function(b){b.querySelector('b').textContent=c.item_count;b.classList.toggle('has-items',c.item_count>0);b.classList.remove('is-bump');void b.offsetWidth;b.classList.add('is-bump')});
  }).catch(function(){})};
  var addToCart=function(body){return fetch(ROOT+'cart/add.js',{method:'POST',body:body,headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}}).then(function(r){if(!r.ok)throw r;return r.json()})};

  d.addEventListener('click',function(e){
    var b=e.target.closest('[data-sg-quick]');if(!b)return;e.preventDefault();
    if(b.classList.contains('is-loading'))return;b.classList.add('is-loading');
    var fd=new FormData();fd.append('id',b.dataset.sgQuick);fd.append('quantity','1');
    addToCart(fd).then(function(){if(d.querySelector('[data-sg-cart]')){location.reload();return}b.classList.remove('is-loading');b.classList.add('is-done');b.querySelector('span').textContent='✓';burst(b);refreshCount();showToast(b.dataset.title,b.dataset.img);setTimeout(function(){b.classList.remove('is-done');b.querySelector('span').textContent='+'},2200)})
      .catch(function(){location.href=ROOT+'cart/add?id='+b.dataset.sgQuick+'&quantity=1'});
  });

  var pform=d.querySelector('.sg-product-form');
  if(pform){
    pform.addEventListener('submit',function(e){
      if(!window.fetch||!window.FormData)return;e.preventDefault();
      var btn=pform.querySelector('[data-sg-add]'),lbl=btn.querySelector('span'),old=lbl.textContent;
      btn.disabled=true;lbl.textContent='adding…';
      addToCart(new FormData(pform)).then(function(){
        lbl.textContent='added!';burst(btn);refreshCount();
        var t=d.querySelector('.sg-pinfo h1'),im=d.querySelector('[data-sg-main-img]');showToast(t&&t.textContent,im&&im.src);
        setTimeout(function(){lbl.textContent=old;btn.disabled=false},1800);
      }).catch(function(){btn.disabled=false;lbl.textContent=old;pform.submit()});
    });
    // sticky buy bar
    var sticky=d.querySelector('[data-sg-sticky]'),mainBtn=pform.querySelector('[data-sg-add]');
    if(sticky&&mainBtn&&'IntersectionObserver' in window){
      new IntersectionObserver(function(es){es.forEach(function(en){var on=!en.isIntersecting&&en.boundingClientRect.top<0;sticky.classList.toggle('is-on',on);sticky.setAttribute('aria-hidden',on?'false':'true');var sb=sticky.querySelector('a,button');if(sb)sb.tabIndex=on?0:-1})}).observe(mainBtn);
      var sAdd=sticky.querySelector('[data-sg-sticky-add]');if(sAdd)sAdd.addEventListener('click',function(){if(pform.requestSubmit)pform.requestSubmit();else pform.dispatchEvent(new Event('submit',{cancelable:true}))});
    }
    // swipe dots
    var sw=d.querySelector('[data-sg-swipe]'),dots=d.querySelectorAll('[data-sg-dots] i');
    if(sw&&dots.length){sw.addEventListener('scroll',function(){var i=Math.round(sw.scrollLeft/(sw.firstElementChild.offsetWidth+12));dots.forEach(function(x,j){x.classList.toggle('is-on',j===i)})},{passive:true})}
  }

  // ---------- videos: never autoplay, open on demand ----------
  var modal=d.querySelector('[data-sg-modal]');
  var openModal=function(node){if(!modal)return;var m=modal.querySelector('[data-sg-modal-media]');m.innerHTML='';m.appendChild(node);modal.classList.add('is-open');modal.setAttribute('aria-hidden','false')};
  var closeModal=function(){if(!modal)return;modal.classList.remove('is-open');modal.setAttribute('aria-hidden','true');setTimeout(function(){modal.querySelector('[data-sg-modal-media]').innerHTML=''},300)};
  if(modal){modal.querySelectorAll('[data-sg-modal-close]').forEach(function(x){x.addEventListener('click',closeModal)});d.addEventListener('keydown',function(e){if(e.key==='Escape')closeModal()})}
  var desc=d.querySelector('[data-sg-desc]'),watch=d.querySelector('[data-sg-watch]');
  if(desc&&watch){
    var vids=[].slice.call(desc.querySelectorAll('iframe[src*="youtu"],iframe[src*="vimeo"],video'));
    if(vids.length){
      var first=vids[0].cloneNode(true);
      vids.forEach(function(v){var p=v.parentElement;v.remove();if(p&&p!==desc&&!p.textContent.trim()&&!p.querySelector('img'))p.remove()});
      watch.hidden=false;
      watch.addEventListener('click',function(){
        var n=first.cloneNode(true);
        if(n.tagName==='IFRAME'){var src=n.getAttribute('src')||'';n.setAttribute('src',src+(src.indexOf('?')>-1?'&':'?')+'autoplay=1');n.setAttribute('allow','autoplay; encrypted-media; picture-in-picture');n.removeAttribute('width');n.removeAttribute('height')}
        else{n.setAttribute('controls','');n.autoplay=true;n.removeAttribute('width');n.removeAttribute('height')}
        openModal(n);
      });
    }
  }
  // youtube facades
  d.querySelectorAll('[data-sg-yt]').forEach(function(b){b.addEventListener('click',function(){
    var f=d.createElement('iframe');f.src='https://www.youtube-nocookie.com/embed/'+b.dataset.sgYt+'?autoplay=1&rel=0';f.allow='autoplay; encrypted-media; picture-in-picture';f.allowFullscreen=true;f.title='YouTube video';
    b.innerHTML='';b.appendChild(f);b.style.cursor='default';
  },{once:true})});


  // glitter trail + goo cursor + hero parallax (desktop only)
  if(!reduce&&window.matchMedia&&matchMedia('(pointer:fine)').matches){
    var hero=d.querySelector('[data-sg-sparkle]'),cols=['#ff8fc8','#b693ff','#8fe6b4','#ffd966','#8fdcff'],last=0;
    if(hero&&allowTrail){hero.addEventListener('pointermove',function(e){var now=Date.now();if(now-last<40)return;last=now;var r=hero.getBoundingClientRect(),s=d.createElement('span');s.className='sg-sparkle';s.style.left=(e.clientX-r.left)+'px';s.style.top=(e.clientY-r.top)+'px';s.style.background=cols[Math.floor(Math.random()*5)];var sz=8+Math.random()*10;s.style.width=s.style.height=sz+'px';s.style.setProperty('--dx',(Math.random()*40-20)+'px');s.style.setProperty('--dy',(20+Math.random()*30)+'px');hero.appendChild(s);setTimeout(function(){s.remove()},900)})}
    if(allowCursor){var cur=d.createElement('div');cur.className='sg-cursor';cur.setAttribute('aria-hidden','true');d.body.appendChild(cur);
    var tx=-100,ty=-100,cx=-100,cy=-100;
    d.addEventListener('pointermove',function(e){tx=e.clientX;ty=e.clientY;var t=e.target.closest&&e.target.closest('a,button,label,[data-sg-quick]');cur.classList.toggle('is-big',!!t)},{passive:true});
    (function loop(){cx+=(tx-cx)*.18;cy+=(ty-cy)*.18;var sx=1+Math.min(Math.abs(tx-cx)/120,.5);cur.style.transform='translate('+cx+'px,'+cy+'px) scale('+sx+','+(2-sx)+')';requestAnimationFrame(loop)})();}
    var hh=d.querySelector('.sg-hero');
    if(hh){hh.addEventListener('pointermove',function(e){var r=hh.getBoundingClientRect();hh.style.setProperty('--mx',((e.clientX-r.left)/r.width*2-1).toFixed(3));hh.style.setProperty('--my',((e.clientY-r.top)/r.height*2-1).toFixed(3))});hh.addEventListener('pointerleave',function(){hh.style.setProperty('--mx',0);hh.style.setProperty('--my',0)})}
  }
})();
